import React from 'react';

import { Table, Button, Form, InputGroup, Pagination } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import { useSelector } from 'react-redux'

import time from 'service/time'

function BoardList({ title, posts, root }) {
    let id = useSelector(state => state.userInfo.id);

    const [page, setPage] = React.useState(1);
    const [search, setSearch] = React.useState('');
    const [searchText, setSearchText] = React.useState('');
    console.log(posts)

    const navigate = useNavigate();
    const handleOnClick = (id) => navigate(`/${root}/${id}`, { replace: false });

    function CustomPage() {
        let len = parseInt((posts.length - 1) / 10) + 1;
        let start = parseInt(page / 10) + 1;
        let end = (parseInt((start - 1) / 10) + 1) * 10
        console.log(len, end)
        end = end > len ? len : end;
        let elements = []
        for (let i = start; i <= end; i++) {

            if (i === page)
                elements.push(<Pagination.Item active >{i}</Pagination.Item>)
            else
                elements.push(<Pagination.Item onClick={() => { setPage(i) }}>{i}</Pagination.Item>)
        }


        return elements;
    }

    return (
        <div className="m-3" style={{ textAlign: "left" }}>
            <div className="d-flex justify-content-between align-items-end">
                <h3>
                    {title}
                </h3>
                <div>
                    <InputGroup className="mb-2" size="sm">
                        <Form.Control style={{ width: "15vw" }} value={searchText} onChange={(e) => { setSearchText(e.target.value) }} onKeyDown={(e) => { if (e.key === 'Enter') { setSearch(searchText); setSearchText('') } }} />
                        <Button variant="outline-secondary" id="button-addon2" onClick={() => { setSearch(searchText); setSearchText(''); }}>
                            검색
                        </Button>
                    </InputGroup>
                </div>
            </div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th className="text-center" width="8%">#</th>
                        <th className="text-center" width="72%">제목</th>
                        <th className="text-center" width="20%">날짜</th>
                    </tr>
                </thead>
                <tbody>
                    {posts.length !== 0 ? posts.filter(item => item.title.indexOf(search) >= 0 || item.contents.indexOf(search) >= 0).filter((item, idx) => idx >= (page - 1) * 10 && idx < page * 10).map(item => {
                        return <tr onClick={() => { handleOnClick(item.id) }} style={{ cursor: "pointer" }}>
                            <td className="text-center">{item.id}</td>
                            <td>{item.title}</td>
                            <td className="text-center">{time.parseDate(item.date)}</td>
                        </tr>
                    }) : <tr><td className="text-center" colSpan="3">비어 있음</td></tr>}
                </tbody>
            </Table>
            <div className="text-end">
                {id ?
                    <Button onClick={() => { navigate(`/${root}/write`, { replace: false }) }} >
                        글쓰기
                    </Button> : <></>
                }
            </div>
            <div>
                <Pagination className="justify-content-center">
                    <Pagination.First onClick={() => { setPage(1) }} />
                    <Pagination.Prev onClick={() => { setPage(page === 1 ? page : page - 1) }} />
                    <CustomPage />
                    <Pagination.Next onClick={() => { setPage(page === parseInt(posts.length / 10) + 1 ? page : page + 1) }} />
                    <Pagination.Last onClick={() => { setPage(parseInt(posts.length / 10) + 1) }} />
                </Pagination>
            </div>
        </div>
    );
}

export default BoardList;